export default "__VITE_ASSET__D1ri0Jis__"